module.exports = __webpack_public_path__ + "static/img/pinpai-17.153a5a96.png";